import { API } from "@/lib/api";

export const LMS_CACHE = "icdh-lms-v1";
const KEY = "icdh_offline_docs";

export function offlineSet() {
  try { return new Set(JSON.parse(localStorage.getItem(KEY) || "[]")); } catch { return new Set(); }
}
export function isOffline(id) { return offlineSet().has(id); }

function markOffline(id) {
  const s = offlineSet();
  s.add(id);
  localStorage.setItem(KEY, JSON.stringify([...s]));
  window.dispatchEvent(new Event("lms-offline-changed"));
}

export function docViewUrl(doc) { return `${API}/lms/documents/${doc.id}/view`; }

export function docExt(doc) {
  if (doc.kind === "pdf") return "pdf";
  if (doc.kind === "html") return "html";
  return "bin";
}

// SCORM packages and external links are excluded (no single downloadable file)
export function downloadable(doc) {
  return !!doc && !doc.is_package && (doc.kind === "pdf" || doc.kind === "html");
}

async function fetchFull(doc) {
  const resp = await fetch(docViewUrl(doc), { credentials: "include" });
  if (!resp.ok) throw new Error("fetch failed " + resp.status);
  return resp;
}

async function putInCache(doc, resp) {
  if (!("caches" in window)) return;
  try {
    const cache = await caches.open(LMS_CACHE);
    await cache.put(new URL(docViewUrl(doc)).pathname, resp);
  } catch (_) { /* ignore quota / opaque errors */ }
}

// Save the file to the device (browser download) AND cache it for offline in-app viewing.
export async function downloadForOffline(doc) {
  const resp = await fetchFull(doc);
  const blob = await resp.clone().blob();
  await putInCache(doc, resp);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const safe = (doc.title || "document").replace(/[^\w\-. ]+/g, "_").trim() || "document";
  a.download = `${safe}.${docExt(doc)}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  markOffline(doc.id);
}

// Silently cache a document for offline viewing (called when a doc is opened).
export async function cacheForOffline(doc) {
  if (!downloadable(doc)) return;
  try {
    const resp = await fetchFull(doc);
    await putInCache(doc, resp);
    markOffline(doc.id);
  } catch (_) { /* offline or fetch error — ignore */ }
}
